import { Component, OnInit, OnDestroy } from '@angular/core';
import { applyLayoutTheme, LAYOUT_THEMES, LAYOUT_THEME_STORAGE_KEY, LayoutThemeValue, normalizeLayoutTheme } from '../../../providers/layout-theme/layout-theme';

import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { DialogLightComponent } from '../../../ui/dialog-light/dialog-light';

@Component({
  selector: 'app-alunos-anamnese',
  templateUrl: './anamnese.component.html',
  styleUrls: ['./anamnese.component.scss']
})
export class AlunosAnamneseComponent implements OnInit, OnDestroy {

  readonly layoutThemes = LAYOUT_THEMES;
  private readonly windowThemeKey = 'st_anamnesis_layout_theme';
  selectedLayoutTheme: LayoutThemeValue = 'modern-dark';
  loading: boolean = false;

  constructor(
    public dialog: MatDialog,
    public toastr: ToastrService,
  ) {
    // this.teacherCode = this.route.snapshot.params.code;
  }

  ngOnInit() {
    this.selectedLayoutTheme = normalizeLayoutTheme(sessionStorage.getItem(this.windowThemeKey) || localStorage.getItem(LAYOUT_THEME_STORAGE_KEY));
    applyLayoutTheme(this.selectedLayoutTheme);
  }

  changeLayoutTheme(theme: string): void {
    this.selectedLayoutTheme = normalizeLayoutTheme(theme);
    sessionStorage.setItem(this.windowThemeKey, this.selectedLayoutTheme);
    applyLayoutTheme(this.selectedLayoutTheme);
  }

  ngOnDestroy(): void {
    // Returning to the admin restores its own preference, including changes from other tabs.
    applyLayoutTheme(normalizeLayoutTheme(localStorage.getItem(LAYOUT_THEME_STORAGE_KEY)));
  }

  getSelectedLayoutThemeLabel(): string {
    const selected = this.layoutThemes.find(theme => theme.value === this.selectedLayoutTheme);
    return selected ? selected.label : 'Modern Dark';
  }


  helpWaitline() {
    let msg = '';
    msg += '<p>Para obter alunos na lista, divulgue o link acima em seu site e nas suas redes sociais.</p>';
    msg += '<p>Os alunos pré-cadastrados não somarão como alunos efetivos no seu plano, exceto se forem aceitos.</p>';
    msg += '<p>Procure aceitar possíveis alunos para um período grátis e aumentar suas chances de conversão.</p>';

    const dialogRef = this.dialog.open(DialogLightComponent, { width: '360px', data: { message: msg } });
    dialogRef.afterClosed().subscribe(_result => {});
  }


}
